import { internetCategory } from '~/api/oneBoxV3/oneBoxV3.type';
import {
  TEditInternetResourceFrom,
  TEditResourceForm,
} from '~/components/Admin/AdminComponent.type';

export const defaultEditResourceForm: TEditResourceForm = {
  originalFileId: '',
  isLaunch: false,
  categories: [],
  versions: [],
  years: [],
  eduCodes: [],
  grades: [],
  subjects: [],
  resources1: [],
  resources2: [],
  resources3: [],
  chapterKeyword: [],
  knowledge: [],
  displayName: '',
};

export const defaultInternetEditResourceForm: TEditInternetResourceFrom = {
  _id: '',
  isLaunch: false,
  category: [internetCategory.PUBLIC],
  years: [],
  eduCodes: [],
  subjects: [],
  grades: [],
  resources1: [],
  resources2: [],
  urlName: '',
  url: '',
};
